import { ControlledMaskInput } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { Masks } from 'constants/masks';

import type { TWorkplaceFormFields } from 'entities/creditForm';

export const EmployerInn: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { trigger } = useFormContext<TWorkplaceFormFields>();

  const handleBlur = () => {
    trigger(type as keyof TWorkplaceFormFields);
  };

  return (
    <div onBlur={handleBlur}>
      <ControlledMaskInput
        {...props}
        name={type}
        mask={Masks.INN}
        maskPlaceholder=""
        inputMode="numeric"
      />
    </div>
  );
};
